/* eslint-disable max-lines */
/* eslint-disable no-magic-numbers */
/* eslint-disable sort-keys */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.avonV2Light = void 0;
/**
 * @todo refactor(styles): replace magic numbers by tokens (including opacity, padding and sizing)
 */
var hex_to_rgba_1 = __importDefault(require("hex-to-rgba"));
var natds_themes_1 = __importDefault(require("@naturacosmeticos/natds-themes"));
var tokens_1 = __importDefault(require("../../tokens"));
var typography_1 = require("./typography");
var typography_2 = require("../../tokens/typography");
var spacing_1 = require("../../tokens/spacing");
var avatarSizes_1 = require("../../tokens/avatarSizes");
var buttonSizes_1 = require("../../tokens/buttonSizes");
var elevation_1 = require("../../tokens/elevation");
var iconSizes_1 = require("../../tokens/iconSizes");
var sizes_1 = require("../../tokens/sizes");
var opacity_1 = require("../../tokens/opacity");
var 
/**
 * @deprecated `avonV2LightColorTokens` are deprecated since v0.20 and will be removed at v1.0.
 * Please use `theme.avon.light.color` from `natds-themes`.
 */
avonV2LightColorTokens = tokens_1.default.colorTokens.avonV2LightColorTokens;
var _a = natds_themes_1.default.avon_v2.light, color = _a.color, opacity = _a.opacity, asset = _a.asset;
exports.avonV2Light = {
    asset: asset,
    shape: {
        borderRadius: tokens_1.default.radius.medium,
        badgeBorderRadius: 100
    },
    avatarSizes: avatarSizes_1.avatarSizes,
    buttonSizes: buttonSizes_1.buttonSizes,
    color: color,
    iconSizes: iconSizes_1.iconSizes,
    /**
     * @since 0.22
     * @todo Adopt opacity tokens from theme
     */
    opacity: opacity_1.opacity,
    sizes: sizes_1.sizes,
    spacing: spacing_1.spacing.spacing,
    palette: {
        action: {
            /**
             * @since 0.24
             */
            active: (0, hex_to_rgba_1.default)(color.highlight, opacity.mediumHigh),
            disabled: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.24)
        },
        /**
         * @since 0.24
         */
        divider: avonV2LightColorTokens.colorLowEmphasis,
        primary: {
            main: avonV2LightColorTokens.colorPrimary,
            light: avonV2LightColorTokens.colorPrimaryLight,
            dark: avonV2LightColorTokens.colorPrimaryDark,
            contrastText: avonV2LightColorTokens.colorOnPrimary
        },
        secondary: {
            main: avonV2LightColorTokens.colorSecondary,
            light: avonV2LightColorTokens.colorSecondaryLight,
            dark: avonV2LightColorTokens.colorSecondaryDark,
            contrastText: avonV2LightColorTokens.colorOnSecondary
        },
        error: {
            main: avonV2LightColorTokens.colorAlert,
            contrastText: avonV2LightColorTokens.colorOnAlert
        },
        success: {
            main: avonV2LightColorTokens.colorSuccess,
            contrastText: avonV2LightColorTokens.colorOnSuccess
        },
        background: {
            paper: avonV2LightColorTokens.colorSurface,
            default: avonV2LightColorTokens.colorBackground,
            paperContrastText: avonV2LightColorTokens.colorOnSurface,
            defaultContrastText: avonV2LightColorTokens.colorOnBackground
        },
        text: {
            primary: avonV2LightColorTokens.colorHighEmphasis,
            secondary: avonV2LightColorTokens.colorMediumEmphasis,
            disabled: avonV2LightColorTokens.colorLowEmphasis,
            hint: avonV2LightColorTokens.colorLowEmphasis
        },
        complementary: {
            highlight: avonV2LightColorTokens.colorHighlight,
            link: avonV2LightColorTokens.colorLink,
            linkContrastText: avonV2LightColorTokens.colorOnLink,
            warning: avonV2LightColorTokens.colorWarning,
            warningContrastText: avonV2LightColorTokens.colorOnWarning
        }
    },
    typography: __assign(__assign({}, typography_1.typography), typography_2.fontSize),
    shadows: elevation_1.elevation,
    overrides: {
        MuiButton: {
            outlinedPrimary: {
                color: avonV2LightColorTokens.colorHighEmphasis
            },
            outlinedSecondary: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                '&.Mui-disabled': {
                    borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                }
            },
            sizeSmall: __assign(__assign({}, buttonSizes_1.buttonSizes.small), typography_2.fontSize.subtitle2),
            root: __assign(__assign({}, buttonSizes_1.buttonSizes.medium), typography_2.fontSize.subtitle2),
            sizeLarge: __assign(__assign({}, buttonSizes_1.buttonSizes.large), typography_2.fontSize.subtitle2),
            text: {
                padding: null,
                '&.Mui-disabled': {
                    color: "".concat(avonV2LightColorTokens.colorHighlight, "3D"),
                    borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                }
            },
            contained: {
                '&.Mui-disabled': {
                    color: "".concat(avonV2LightColorTokens.colorHighlight, "3D"),
                    backgroundColor: "".concat(avonV2LightColorTokens.colorHighlight, "14")
                }
            },
            outlined: {
                padding: null,
                borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D"),
                '&.Mui-disabled': {
                    color: "".concat(avonV2LightColorTokens.colorHighlight, "3D"),
                    borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                }
            }
        },
        MuiAvatar: {
            colorDefault: {
                color: avonV2LightColorTokens.colorHighEmphasis
            }
        },
        MuiIconButton: {
            root: {
                padding: '8px',
                color: avonV2LightColorTokens.colorHighEmphasis
            },
            sizeSmall: {
                padding: '4px'
            }
        },
        MuiExpansionPanel: {
            root: {
                border: 'transparent 1px solid',
                '&$expanded': {
                    borderColor: avonV2LightColorTokens.colorPrimary
                },
                '&$disabled': {
                    backgroundColor: avonV2LightColorTokens.colorOnPrimary,
                    opacity: 0.32
                }
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                alignItems: 'flex-start',
                marginTop: '8px',
                '&$disabled': {
                    opacity: 1
                }
            }
        },
        MuiToolbar: {
            root: {
                padding: '0 16px',
                '@media (min-width: 600px)': {
                    padding: '0 16px'
                }
            },
            gutters: {
                padding: '0 16px',
                '@media (min-width: 600px)': {
                    padding: '0 16px'
                }
            },
            regular: {
                minHeight: '56px',
                '@media (min-width: 600px)': {
                    minHeight: '56px'
                }
            },
            dense: {
                minHeight: '56px',
                '@media (min-width: 600px)': {
                    minHeight: '56px'
                }
            }
        },
        MuiListItem: {
            root: {
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorOnSecondary, 0.04)
                },
                '&$selected': {
                    backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorPrimary, 0.16),
                    '&:hover': {
                        backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.04)
                    },
                    '&:focus': {
                        outline: 'none'
                    }
                },
                '&.Mui-disabled': {
                    opacity: 0.32
                }
            },
            gutters: {
                '&:focus': {
                    outline: 'none'
                }
            },
            button: {
                '&:hover': {
                    backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.04)
                }
            }
        },
        MuiBadge: {
            badge: {
                padding: '0 4px'
            }
        },
        MuiTab: {
            root: {
                '&$disabled': {
                    opacity: 0.24
                }
            },
            textColorInherit: {
                '&$disabled': {
                    opacity: 0.24
                }
            },
            wrapper: {
                '& > *:first-child': {
                    marginBottom: '2px !important'
                }
            }
        },
        MuiChip: {
            root: {
                backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.12),
                color: avonV2LightColorTokens.colorHighEmphasis,
                fontSize: typography_2.fontSize.subtitle2.fontSize,
                '& $avatar': {
                    backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.24),
                    color: avonV2LightColorTokens.colorHighEmphasis
                },
                '&$disabled': {
                    opacity: 0.4
                }
            },
            clickableColorPrimary: {
                '&:hover': {
                    backgroundColor: avonV2LightColorTokens.colorPrimary
                }
            },
            clickableColorSecondary: {
                '&:hover': {
                    backgroundColor: avonV2LightColorTokens.colorSecondary
                }
            },
            outlined: {
                borderColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.12),
                color: avonV2LightColorTokens.colorHighlight
            },
            outlinedPrimary: {
                color: avonV2LightColorTokens.colorHighlight
            },
            outlinedSecondary: {
                color: avonV2LightColorTokens.colorHighlight
            },
            icon: {
                fontSize: "".concat(sizes_1.sizes.standard, "px")
            },
            iconSmall: {
                width: "".concat(sizes_1.sizes.small, "px"),
                height: "".concat(sizes_1.sizes.small, "px"),
                fontSize: "".concat(sizes_1.sizes.small, "px"),
                marginTop: '1px'
            },
            deleteIcon: {
                width: "".concat(sizes_1.sizes.standard, "px"),
                height: "".concat(sizes_1.sizes.standard, "px"),
                fontSize: "".concat(sizes_1.sizes.standard, "px"),
                color: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorHighlight, 0.8),
                '&:hover': {
                    color: avonV2LightColorTokens.colorHighlight
                }
            },
            deleteIconSmall: {
                width: "".concat(sizes_1.sizes.small, "px"),
                height: "".concat(sizes_1.sizes.small, "px"),
                fontSize: "".concat(sizes_1.sizes.small, "px")
            },
            deleteIconColorPrimary: {
                color: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorOnPrimary, 0.8),
                '&:hover': {
                    color: avonV2LightColorTokens.colorOnPrimary
                }
            },
            deleteIconColorSecondary: {
                color: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorOnSecondary, 0.8),
                '&:hover': {
                    color: avonV2LightColorTokens.colorOnSecondary
                }
            }
        },
        MuiTextField: {
            '& .MuiInputLabel': {
                marginTop: '20px'
            }
        },
        MuiInputBase: {
            root: {
                fontSize: typography_2.fontSize.subtitle2.fontSize,
                borderRadius: '4px',
                boxShadow: "".concat(avonV2LightColorTokens.colorLowEmphasis, " 0 0 0 1px"),
                color: avonV2LightColorTokens.colorHighEmphasis,
                width: '100%',
                "&[data-state='error']": {
                    boxShadow: "".concat(avonV2LightColorTokens.colorAlert, " 0 0 0 1px")
                },
                "&[data-state='success']": {
                    boxShadow: "".concat(avonV2LightColorTokens.colorSuccess, " 0 0 0 1px")
                },
                '&:hover': {
                    boxShadow: "".concat(avonV2LightColorTokens.colorMediumEmphasis, " 0 0 0 1px"),
                    '&.Mui-disabled': {
                        boxShadow: "".concat(avonV2LightColorTokens.colorLowEmphasis, " 0 0 0 1px")
                    }
                },
                '&.Mui-focused': {
                    boxShadow: "".concat(avonV2LightColorTokens.colorPrimary, " 0 0 0 2px")
                },
                '&.MuiFilled:not(.Mui-focused)': {
                    boxShadow: "".concat(avonV2LightColorTokens.colorHighEmphasis, " 0 0 0 1px"),
                    '&:hover': {
                        boxShadow: "".concat(avonV2LightColorTokens.colorMediumEmphasis, " 0 0 0 1px")
                    }
                },
                '&.MuiInputBase-multiline': {
                    padding: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.none
                },
                '&.MuiInput-underline:before': {
                    borderBottom: 'none'
                },
                '&.MuiInput-underline.Mui-disabled:before': {
                    borderBottomStyle: 'none'
                },
                '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: 'none'
                },
                '&.MuiInput-underline:after': {
                    borderBottom: 'none'
                }
            },
            adornedEnd: {
                paddingRight: sizes_1.sizes.medium
            },
            input: {
                '&.Mui-disabled:not(::placeholder)': {
                    opacity: 0.24
                },
                '&::placeholder': {
                    color: avonV2LightColorTokens.colorMediumEmphasis
                },
                '&.MuiInput-inputTypeSearch': {
                    paddingRight: sizes_1.sizes.large
                },
                border: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.none,
                boxSizing: 'border-box',
                lineHeight: "".concat(sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.standard, "px"),
                minHeight: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.mediumX,
                padding: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.small
            },
            inputMultiline: {
                padding: sizes_1.sizes === null || sizes_1.sizes === void 0 ? void 0 : sizes_1.sizes.small
            },
            inputTypeSearch: {
                '&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration': {
                    display: 'none'
                }
            }
        },
        MuiInputAdornment: {
            root: {
                position: 'absolute',
                right: '0'
            },
            positionEnd: {
                marginRight: spacing_1.spacing.spacingTiny
            }
        },
        MuiInputLabel: {
            formControl: {
                position: 'relative',
                transform: 'none',
                marginTop: '-4px'
            },
            shrink: {
                transform: 'none',
                marginTop: '-4px'
            }
        },
        MuiFormLabel: {
            root: {
                fontSize: typography_2.fontSize.subtitle2.fontSize,
                '&.Mui-focused': {
                    fontSize: typography_2.fontSize.subtitle2.fontSize,
                    color: avonV2LightColorTokens.colorMediumEmphasis
                },
                '&.Mui-error': {
                    color: avonV2LightColorTokens.colorAlert
                }
            }
        },
        MuiButtonGroup: {
            groupedOutlinedHorizontal: {
                '&:not(:first-child)': {
                    marginLeft: 'none'
                }
            },
            groupedContainedPrimary: {
                '&:not(:last-child)': {
                    borderColor: avonV2LightColorTokens.colorPrimaryDark,
                    '&.Mui-disabled': {
                        borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                    }
                }
            },
            groupedContainedSecondary: {
                '&:not(:last-child)': {
                    borderColor: avonV2LightColorTokens.colorSecondaryDark,
                    '&.Mui-disabled': {
                        borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                    }
                }
            },
            groupedContainedHorizontal: {
                '&:not(:last-child)': {
                    borderRightColor: "".concat(avonV2LightColorTokens.colorHighlight, "1F"),
                    '&.Mui-disabled': {
                        borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                    }
                }
            },
            groupedTextPrimary: {
                '&:not(:last-child).Mui-disabled': {
                    borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                }
            },
            groupedTextSecondary: {
                '&:not(:last-child).Mui-disabled': {
                    borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                }
            },
            groupedTextHorizontal: {
                '&:not(:last-child)': {
                    borderRightColor: "".concat(avonV2LightColorTokens.colorHighlight, "1F"),
                    '&.Mui-disabled': {
                        borderColor: "".concat(avonV2LightColorTokens.colorHighlight, "3D")
                    }
                }
            }
        },
        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent'
                },
                '&.Mui-disabled': {
                    color: avonV2LightColorTokens.colorLowEmphasis
                }
            },
            icon: {
                top: sizes_1.sizes.micro,
                color: avonV2LightColorTokens.colorHighEmphasis
            }
        },
        MuiAlert: {
            root: __assign({ width: 278, padding: spacing_1.spacing.spacingSmall }, typography_2.fontSize.body1),
            icon: {
                marginRight: spacing_1.spacing.spacingTiny
            },
            message: {
                padding: '5px 0'
            },
            standardSuccess: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorSuccess, 0.16)
            },
            outlinedSuccess: {
                color: avonV2LightColorTokens.colorHighEmphasis
            },
            standardError: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorAlert, 0.16)
            },
            outlinedError: {
                color: avonV2LightColorTokens.colorHighEmphasis
            },
            standardWarning: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorWarning, 0.16),
                '& .MuiAlert-icon': {
                    color: avonV2LightColorTokens.colorWarning
                }
            },
            outlinedWarning: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                borderColor: avonV2LightColorTokens.colorWarning,
                '& .MuiAlert-icon': {
                    color: avonV2LightColorTokens.colorWarning
                }
            },
            filledWarning: {
                color: avonV2LightColorTokens.colorOnWarning,
                backgroundColor: avonV2LightColorTokens.colorWarning
            },
            standardInfo: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                backgroundColor: (0, hex_to_rgba_1.default)(avonV2LightColorTokens.colorLink, 0.16),
                '& .MuiAlert-icon': {
                    color: avonV2LightColorTokens.colorLink
                }
            },
            outlinedInfo: {
                color: avonV2LightColorTokens.colorHighEmphasis,
                borderColor: avonV2LightColorTokens.colorLink,
                '& .MuiAlert-icon': {
                    color: avonV2LightColorTokens.colorLink
                }
            },
            filledInfo: {
                backgroundColor: avonV2LightColorTokens.colorLink
            }
        },
        MuiAlertTitle: {
            root: __assign({}, typography_2.fontSize.h6)
        },
        MuiTableSortLabel: {
            icon: {
                marginLeft: spacing_1.spacing.spacing
            }
        },
        MuiTablePagination: {
            root: {
                overflow: 'visible',
                '& .MuiSelect-icon': {
                    top: 0,
                    height: '100%'
                }
            },
            input: {
                flexShrink: 'initial'
            }
        }
    }
};
//# sourceMappingURL=avon_v2-light.js.map